import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './permissions-update-modal.component.html',
  standalone: false,
})
export class PermissionsUpdateModalComponent {
  readonly #dialog = inject<BsModalRef<PermissionsUpdateModalComponent>>(BsModalRef);

  public onClose(): void {
    this.#dialog.hide();
  }
}
